import React from 'react';

const SingleAggrete = (props) => {
  const {
    totalSets,
    hospitalSetsByType,
    caseType,
    setPrimaryLabels,
    setRevisionLabels,
    setCaseType
  } = props;

  // const getCaseCount = (data) => {
  //   const caseCounts = data.reduce((acc, item) => {
  //     acc[item.CaseNo] = (acc[item.CaseNo] || 0) + 1;
  //     return acc;
  //   }, {});

  //   const dataList = Object.entries(caseCounts).map(([CaseNo, count]) => ({ CaseNo, count }));

  //   return dataList.length;
  // };

  return (
    <>
      {
        totalSets.length > 0
          ? (
            <table className="table table-noborder plan-table">
              <thead>
                <tr>
                  <th className="text-uppercase">Type</th>
                  <th className="text-center text-uppercase">Cases</th>
                  <th className="text-center text-uppercase">Primary</th>
                  <th className="text-center text-uppercase">Revision</th>
                </tr>
              </thead>
              <tbody>
                {
                  totalSets.map((filteredSet, k) => (
                    <tr className="cursor-pointer" key={k} onClick={() => setCaseType(filteredSet.Type)}>
                      <td>
                        <span
                          className={`cursor-pointer ${caseType === filteredSet.Type ? 'badge badge-warning' : 'theme-color'}`}
                        >
                          {filteredSet.Type}
                        </span>
                      </td>
                      <td className="text-center">{filteredSet.Cases}</td>
                      <td className="text-center">{(filteredSet.PrimaryCount > 0) ? filteredSet.PrimaryCount : ''}
                        {`${setPrimaryLabels(filteredSet)}`}
                      </td>
                      <td className="text-center">{(filteredSet.RevisionCount > 0) ? filteredSet.RevisionCount : ''}
                        {`${setRevisionLabels(filteredSet)}`}
                      </td>
                    </tr>
                  ))
                }
                <tr className="cursor-pointer" onClick={() => setCaseType('all')}>
                  <td>
                    <span
                      className={`cursor-pointer ${caseType === 'all' ? 'badge badge-warning' : 'theme-color'}`}
                    >All
                    </span>
                  </td>
                  <td className="text-center">
                    {
                      totalSets.reduce((prev, current) => (
                        (prev + +current.Cases) > 0 && (prev + +current.Cases)
                      ), 0)
                    }
                  </td>
                  <td className="text-center">
                    {
                      totalSets.reduce((prev, current) => (
                        (prev + +current.PrimaryCount) > 0 && (prev + +current.PrimaryCount)
                      ), 0)
                    }
                  </td>
                  <td className="text-center">
                    {
                      totalSets.reduce((prev, current) => (
                        (prev + +current.RevisionCount) > 0 && (prev + +current.RevisionCount)
                      ), 0)
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          ) : ''
      }

      {
        Object.keys(hospitalSetsByType).length > 0
          ? (
            Object.keys(hospitalSetsByType).map((sets) => (
              <div key={sets}>
                <h4 className="setName">{sets.toLowerCase()}{(hospitalSetsByType[sets]).length > 1 ? 's' : ''}</h4>
                <table className="table table-bordered plan-table">
                  <tbody>
                    {
                      hospitalSetsByType[sets].map((set, s) => (
                        <tr className={s} key={s}>
                          <td className="col-10">{set.SetName}</td>
                          <td className="col-2 text-center">{set.count}</td>
                        </tr>
                      ))
                    }
                    <tr className="row-no-border" key={(hospitalSetsByType[sets].length)}>
                      <td className="col-10" />
                      <td className="col-2 text-center">
                        {/* {
                          caseType === 'all'
                            ? hospitalSetsByType[sets].reduce(
                              (total, currentValue) => (total + +currentValue.count), 0
                            )
                            : getCaseCount(hospitalSetsByType[sets])
                        } */}
                        {
                          hospitalSetsByType[sets].reduce(
                            (total, currentValue) => (total + +currentValue.count), 0
                          )
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))
          ) : ''
      }
    </>
  );
};

export default SingleAggrete;
